/* Backend'deki SharedLibrary/Constants/Permissions.cs ile birebir aynidir.
   Menu ve dugmeleri gizlemek icin kullanilir; asil denetim sunucudadir. */

export const P = {
  products: {
    view: 'products.view',
    create: 'products.create',
    update: 'products.update',
    delete: 'products.delete',
    publish: 'products.publish',
    bulk: 'products.bulk',
  },
  inventory: {
    view: 'inventory.view',
    adjust: 'inventory.adjust',
    transfer: 'inventory.transfer',
    locations: 'inventory.locations',
  },
  orders: {
    view: 'orders.view',
    create: 'orders.create',
    update: 'orders.update',
    cancel: 'orders.cancel',
    fulfill: 'orders.fulfill',
    refund: 'orders.refund',
    returns: 'orders.returns',
  },
  customers: {
    view: 'customers.view',
    create: 'customers.create',
    update: 'customers.update',
    delete: 'customers.delete',
  },
  discounts: {
    view: 'discounts.view',
    manage: 'discounts.manage',
  },
  content: {
    view: 'content.view',
    manage: 'content.manage',
  },
  shipping: {
    view: 'shipping.view',
    manage: 'shipping.manage',
  },
  settings: {
    view: 'settings.view',
    manage: 'settings.manage',
  },
  reports: {
    view: 'reports.view',
    export: 'reports.export',
  },
  security: {
    auditView: 'security.audit.view',
    rolesManage: 'security.roles.manage',
    usersManage: 'security.users.manage',
    logsView: 'security.logs.view',
  },
} as const;

export const roleLabels: Record<string, string> = {
  SuperAdmin: 'Süper yönetici',
  Admin: 'Yönetici',
  CatalogManager: 'Katalog sorumlusu',
  OrderManager: 'Sipariş sorumlusu',
  InventoryManager: 'Stok sorumlusu',
  ContentManager: 'İçerik sorumlusu',
  SupportAgent: 'Destek temsilcisi',
  Customer: 'Müşteri',
};

export const permissionLabels: Record<string, string> = {
  'products.view': 'Ürünleri görüntüle',
  'products.create': 'Ürün oluştur',
  'products.update': 'Ürün güncelle',
  'products.delete': 'Ürün sil',
  'products.publish': 'Ürün yayınla',
  'products.bulk': 'Toplu ürün işlemi',
  'inventory.view': 'Stoğu görüntüle',
  'inventory.adjust': 'Stok düzelt',
  'inventory.transfer': 'Stok transferi',
  'inventory.locations': 'Konumları yönet',
  'orders.view': 'Siparişleri görüntüle',
  'orders.create': 'Sipariş oluştur',
  'orders.update': 'Sipariş güncelle',
  'orders.cancel': 'Sipariş iptal et',
  'orders.fulfill': 'Sevkiyat yap',
  'orders.refund': 'İade işle',
  'orders.returns': 'İade taleplerini yönet',
  'customers.view': 'Müşterileri görüntüle',
  'customers.create': 'Müşteri oluştur',
  'customers.update': 'Müşteri güncelle',
  'customers.delete': 'Müşteri sil',
  'discounts.view': 'İndirimleri görüntüle',
  'discounts.manage': 'İndirimleri yönet',
  'content.view': 'İçeriği görüntüle',
  'content.manage': 'İçeriği yönet',
  'shipping.view': 'Kargoyu görüntüle',
  'shipping.manage': 'Kargoyu yönet',
  'settings.view': 'Ayarları görüntüle',
  'settings.manage': 'Ayarları yönet',
  'reports.view': 'Raporları görüntüle',
  'reports.export': 'Rapor dışa aktar',
  'security.audit.view': 'Denetim kaydını görüntüle',
  'security.roles.manage': 'Rolleri yönet',
  'security.users.manage': 'Kullanıcıları yönet',
  'security.logs.view': 'Günlükleri görüntüle',
};
